<template>
<div class="loading-consumer text-center" v-if="!consumerLoaded && $route.name !== 'Invalid Portal'">
  <div class="loading-text">Please wait as we are processing the information!</div>
  <div class="loading-img"><img :src="loadingImg" /></div>
</div>
<div class="header-container sticky-sm-top">
  <router-view class="view main-header" name="InfoHeader"></router-view>
</div>
<div class="container-fluid main-content">
  <div class="row">
    <div class="left-main-content" :class="leftClass">
      <router-view class="view infobox" name="InfoBox"></router-view>
    </div>
    <div class="right-main-content" :class="rightClass">
    <router-view v-slot="{ Component }">
      <transition name="slide-fade">
        <component class="right-component" :is="Component" />
      </transition>
    </router-view>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      loadingImg: process.env.BASE_URL + 'loading.gif'
    }
  },
  computed: {
    leftClass () {
      if (this.$route.name === 'Consumer Information') {
        return {
          'col-md-5': true,
          'col-xl-4': true,
          'col-xxl-3': true
        }
      }
      return {
        'col-md-4': true,
        'col-lg-3': true
      }
    },
    rightClass () {
      if (this.$route.name === 'Consumer Information') {
        return {
          'col-md-7': true,
          'col-xl-8': true,
          'col-xxl-9': true
        }
      }
      return {
        'col-md-8': true,
        'col-lg-9': true
      }
    },
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded'
    })
  }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #333333;
}
#app {
  @include media-breakpoint-up(md) {
    height: 100vh;
  }
}
.main-header {
  padding-bottom: 15px;
}
.main-content {
  @include media-breakpoint-up(md) {
    height: 0;
  }
}
.main-content > .row {
  @include media-breakpoint-up(md) {
    height: 100%;
  }
}
.right-main-content {
  @include media-breakpoint-up(md) {
    height: 100%;
    overflow: auto;
  }
  @media only screen and (min-width: 1600px) {
    width: 80%
  }
}
.left-main-content {
  @media only screen and (min-width: 1600px) {
    width: 20%
  }
}
.zero-height-sm {
  height: auto;
  @include media-breakpoint-up(sm) {
    height: 0px;
    overflow: show;
  }
}
.pull-right{
  float: right;
}
.underline {
  text-decoration: underline;
}
.info-column-left .row .label, .info-column-right .row .label{
  float: left;
  clear: left;
  text-align: right;
  font-weight: bold;
}

.btn-success {
  background-color: #5cb85c;
  border-color: #4cae4c;
  &:hover, &:active {
    background-color: #449d44;
    border-color: #398439;
  }
  &:focus {
    background-color: #449d44;
    border-color: #255625;
  }
}
.btn-danger {
  background-color: #d9534f;
  border-color: #d43f3a;
}
.right-main-content {
  overflow-x: auto;
  white-space: nowrap;
}
.right-component {
  width: 100%;
  white-space: normal;
}
.loading-consumer {
  padding-top: 100px;
}
.slide-fade-enter-active {
  transition: all .4s linear;
  display: inline-block;
  vertical-align: top;
  transform: translateX(-100%)
}

.slide-fade-leave-active {
  transition: all .4s linear;
  display: inline-block;
  vertical-align: top;
}

.slide-fade-enter-from {
  transform: translateX(0);
  opacity: .7;
}
.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: .5;
}

</style>
